import React from 'react';
import PropTypes from 'prop-types';

import BaseViewForm from './0-base-view-form';
import FormManager from 'src/core/gd-form/common/form-manager';
import FormError from 'src/core/gd-form/common/form-error/form-error';
import SelectProjectMulti from "./common-blocks/project-multi";
import SelectUser from 'core/gd-ui/select-user/select-user';
import CommonBlock from "./common-blocks/common-block";
import CommonForm from "./common-blocks/common-form";
import {ViewType} from "../../../../../../core/gd/const/views/view-type";
import {ViewTypeConfigs} from "../../../../../../core/gd/const/views/view-type-config";
import {EntityType} from "../../../../../../core/gd/const/item"

export default class ResourcePlanningForm extends BaseViewForm {

    static propTypes = {
        mode: PropTypes.oneOf(['create', 'update']).isRequired,
        organizationId: PropTypes.string.isRequired,
        onSubmit: PropTypes.func,
        view: PropTypes.object,
        className: PropTypes.string,
    };

    state = {
        projects: [],
        users: [],
    };

    constructor(props) {
        super(props);

        this.viewType = ViewType.RESOURCE_PLANNING;
        this.defaultName = ViewTypeConfigs[this.viewType].name;

        const { view } = this.props;

        const initFormData = this.getViewInitFormData(view, {
            projects:   [],
            users:      [],
        });

        if (view && view.settings) {
            initFormData.projects =     view.settings.projects;
            this.state.projects =       initFormData.projects;
            initFormData.users =        view.settings.users;
        }

        const formStructure = {
            fields: this.getViewFormFields({
                projects:   {type: 'select',    isRequired: false,  label: 'Projects'},
                users:      {type: 'select',    isRequired: false,  label: 'Users'},
            }),
            onSubmit: this.onSubmit,
            isFormChanged: true,
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onParentSelect = (parent) => {
        this.form.onFormComponentValueChange('projects', parent.projects);
        this.updateUsersField('users');
        this.updateUsersField('sharedUsers');
        this.setState({ projects: parent.projects });
    }

    onSubmit = (result) => {
        this.submitData(result, {
            projects: result.projects,
            users: result.users,
        });
    }

    render() {
        const parentValues = this.state.projects ? { projects: this.state.projects } : null;

        const users = this.getUsers();

        return (
            <CommonForm className={this.props.className} form={this.form} mode={this.props.mode}>
                <div className="tbl">
                    <CommonBlock form={this.form} mode={this.props.mode} view={this.props.view} users={users}/>

                    <SelectProjectMulti form            = {this.form}
                                        parentsFor      = {EntityType.PROJECT}
                                        companyId       = {this.props.organizationId}
                                        parentValues    = {parentValues}
                                        onParentSelect  = {this.onParentSelect}/>

                    <div className="row">
                        <div className="label">Users</div>
                        <div className="element">
                            <SelectUser form={this.form}
                                        name="users"
                                        multiselect={true}
                                        options={users}
                                        renderValue="form"
                                        underlined="always"
                                        placeholder="All users"
                                        canHaveNoValue={true}
                                        noValueValue={[]}
                                        noValueLabel="All users" />
                            <FormError form={this.form} name="users" />
                        </div>
                    </div>
                </div>
            </CommonForm>
        );
    }
}